import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Surface } from 'components/canvas/components/top-left-menu/components/breadcrumbs/style';
import { useOnSurfaceChangeOperations } from 'routes/surface/hooks/use-on-surface-change';

interface ParamsProps {
  id?: string;
}

function SurfacesList({ surfaces, onSurfaceSelect }) {
  const history = useHistory();
  const params: ParamsProps = useParams();

  const { setSurfaceId } = useOnSurfaceChangeOperations();

  function navigateToSurface(id) {
    return function () {
      if (id !== params.id) {
        setSurfaceId(id);
        onSurfaceSelect && onSurfaceSelect();
        history.push(`/surface/${id}`);
      }
    };
  }

  return surfaces.map(({ id, name }) => (
    <Surface onClick={navigateToSurface(id)} key={id}>
      {name}
    </Surface>
  ));
}

export default SurfacesList;
